/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getBraindatePath } from '@e180/domain/lib/braindate/util';

import CheckInTakeOverDumb from './CheckInTakeOverDumb';
import { markCheckInTakeOverAsOpen } from 'src/shared/app/check-in/action/uiCheckInActions';
import { dismissNotification } from 'src/shared/app/notification/action/uiNotificationActions';
import { getNotificationData } from 'src/shared/app/notification/util/notificationUtil';
import { trackGAEvent } from 'src/shared/core/service/tracking/gaService';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';
import { getSelf } from 'src/shared/domain/user/selector/userSelectors';

import type { Braindate } from '@e180/domain/lib/braindate/type';
import type { Notification } from 'src/shared/app/notification/type/notificationTypes';

type Props = {
  notification: Notification,
  // Self passed
  history: Object,
};

const mapStateToProps = (state: Object, { notification }: Props): Object => ({
  event: getEventSafely(state),
  notification,
  selfUser: getSelf(state),
});

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: Object,
  { dispatch }: Object,
  ownProps: Props,
): Object => {
  const { notification, history } = ownProps;
  // $FlowIssue
  const braindate: Braindate = getNotificationData(notification);

  return {
    ...stateProps,
    handleClick() {
      dispatch(markCheckInTakeOverAsOpen(braindate));

      history.push(getBraindatePath(braindate));

      trackGAEvent('Self check-in', 'Check in', 'Take over notification');
    },
    handleDismiss() {
      dispatch(dismissNotification(notification));
    },
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(CheckInTakeOverDumb);
